import angular from 'angular';
import '../../services/organization';
import '../../services/organization-scenario';
import '../../services/line-flow-type-organization';
import '../../services/plan';
import '../../services/category';
import '../../services/organization-messages';
import '../../services/place';
import '../../services/globals';
import '../../services/organization-sla';

import { localStorage, options, generateOptions, validPhone, containsEmptyElements, removeEmptyItems, validateLastDigits, optionsTotemVersion } from '../../utils';
import { includes, pull, find, get, set, isNumber } from 'lodash';

const module = angular.module('whyline.modals.organization', [
  'whyline.services.organization',
  'whyline.services.organization-scenario',
  'whyline.services.organization-sla',
  'whyline.services.organization-messages',
  'whyline.services.line-flow-type-organization',
  'whyline.services.plan',
  'whyline.services.category',
  'whyline.services.place',
  'whyline.services.globals',
]);

const OrganizationModalController = (
  SAFE_STATES,
  $scope,
  $uibModalInstance,
  $timeout,
  $state,
  $translate,
  dialog,
  Slug,
  OrganizationService,
  organizationId,
  TimezoneService,
  NotificationService,
  PlanService,
  CategoryService,
  ErrorService,
  LineFlowTypeOrganizationService,
  OrganizationScenarioService,
  OrganizationSlaService,
  OrganizationMessagesService,
  blockUI,
  $rootScope,
  PlaceService,
  GlobalsService
) => {
  /*@ngInject*/

  $scope.currentLanguage = $translate.use();
  $scope.languages = {
    list: { en: 'English', es: 'Español', pt: 'Portugués' },
  };
  $scope.organization = {};
  $scope.organizationGeneral = {};
  $scope.organizationConfiguration = {};
  $scope.organizationMessages = [];
  $scope.hack = { organizationOneLoginEnabled: false };
  $scope.file = [];
  $scope.nameImg = {
    logo: '',
    'agenda.logo': '',
    'agenda.background': '',
  }

  $scope.organizationOneLogin = {
    passportConfig: {
      authorizationURL: '',
      callbackURL: '',
      clientID: '',
      clientSecret: '',
      issuer: '',
      passReqToCallback: true,
      tokenURL: '',
      userInfoURL: '',
    },
    slug: '',
  };
  $scope.plans = [];
  $scope.lineFlowTypeOrganizationList = [];
  $scope.slaOrganizationList = [];
  $scope.lineFlowTypeOrganizationSelected = {};
  $scope.slaOrganizationSelected = {};
  $scope.scenarioSelected = {};
  $scope.timezones = { list: TimezoneService.List };

  $scope.editMessagesScope = {
    options: options.filter((o) => o.onlyOrganizations || o.all),
    selectedOption: options.filter((o) => o.onlyOrganizations || o.all)[0].key,
  };

  $scope.editCallLogicsScope = {
    options: options.filter((o) => o.onlyOrganizations || o.all || o.orgPlacesLines),
    selectedOption: options.filter((o) => o.onlyOrganizations || o.all || o.orgPlacesLines)[0].key,
  };

  $scope.editSlaScope = {
    options: options.filter((o) => o.onlyOrganizations || o.all),
    selectedOption: options.filter((o) => o.onlyOrganizations || o.all)[0].key,
  };

  $scope.noAppointmentsAvailableMessageApplyIn = {
    options: options.filter((o) => o.onlyOrganizations || o.all),
    selectedOption: options.filter((o) => o.onlyOrganizations || o.all)[0].key,
  };

  $scope.selectDataForTotem = generateOptions();
  $scope.totemVersion = optionsTotemVersion;
  $scope.totemVersionSelected = optionsTotemVersion[0];
  $scope.totemVersionChange = (totemVersionSelected) => {
    $scope.organizationConfiguration.currentTotemVersion = totemVersionSelected.version;
  }

  $scope.selectDataForExtraAppointment = generateOptions();

  const user = localStorage.get('user');
  $scope.superAdmin = user && user.sudo;

  const roleName = get(user, 'permissions[0].role.name', '');
  $scope.canEditExtraAppointment = $scope.superAdmin || roleName === 'Organization Admin';
  $scope.canEditAgingSLA = $scope.superAdmin || roleName === 'Organization Admin';

  const SUPPORTED_LANGUAGES = ['en', 'es', 'pt'];
  const DEFAULT_LANGUAGE = 'en';
  const language = includes(SUPPORTED_LANGUAGES, $translate.use())
    ? $translate.use()
    : DEFAULT_LANGUAGE;

  const field = `name_${language}`;

  $scope.categoriesSettings = {
    template: `<b>{{option.${field}}}</b>`,
    externalIdProp: 'category',
    displayProp: field,
    idProp: '_id',
    searchField: field,
    enableSearch: true,
    keyboardControls: true,
    selectedToTop: true,
    scrollable: true,
  };

  $scope.tooltips = {
    checkInEarly: 'tooltip_check_in_early',
    numberPeopleAhead: 'tooltip_people_ahead',
    youAreNext: 'tooltip_you_are_next',
    checkIn: 'tooltip_check_in',
    itsYourTurn: 'tooltip_its_your_turn',
  };

  $scope.multiselectTranslations = {
    checkAll: $translate.instant('multiselect_todos'),
    uncheckAll: $translate.instant('multiselect_ninguno'),
    dynamicButtonTextSuffix: $translate.instant('multiselect_seleccionados'),
    buttonDefaultText: $translate.instant('multiselect_seleccionar'),
    searchPlaceholder: $translate.instant('multiselect_buscar'),
    selectionCount: $translate.instant('multiselect_seleccionados'),
  };

  $scope.cancel = () => {
    dialog
      .confirm($translate.instant('modal_cancel'))
      .then(() => $uibModalInstance.dismiss('cancel'))
      .catch(() => 'canceled');
  };

  $scope.setMinorThanZero = (value, property) => {
    if (value < -1 && $scope.organizationConfiguration.plan.hasOwnProperty(property)) {
      $scope.organizationConfiguration.plan[property] = -1;
    } else if (value === '' || value === null) {
      $scope.organizationConfiguration.plan[property] = 0;
    }
  };

  $scope.changeIdToPlanId = (plan) => {
    if (!plan) {
      return;
    }
    $scope.organizationConfiguration.plan = {
      ...plan,
      planId: plan._id,
    };

    Reflect.deleteProperty($scope.organizationConfiguration.plan, '_id');
  };

  $scope.setLFTOId = (lftoSelected) => {
    $scope.organization.defaultLineFlowTypeOrganization = lftoSelected._id;
  };

  $scope.setSlaId = (slaSelected) => {
    $scope.organization.configuration.agingSLA._id = slaSelected._id;
  };

  $scope.setScenarioId = (scenarioSelected) => {
    $scope.organization.defaultScenario = scenarioSelected._id;
  };

  const isValidLastDigit = () => {
    const { enabled, finishedIn } = $scope.organizationConfiguration.lastDigitsToCallServiceClient;
    const res = validateLastDigits(enabled, finishedIn);

    if (!res.status) {
      NotificationService.Warning($translate.instant(res.msg));
    }

    $scope.organizationConfiguration.lastDigitsToCallServiceClient.finishedIn = res.finishedIn;
    return res.status;
  };

  const isValidLastDigitShowCommercialOffer = () => {
    const { enabledService, finishedIn } = $scope.organization.configuration.showCommercialOffer;
    const res = validateLastDigits(enabledService, finishedIn);
    if (!res.status) {
      NotificationService.Warning($translate.instant('field_finishedIn_commercial_offer_empty'));
    }

    $scope.organization.configuration.showCommercialOffer.finishedIn = res.finishedIn;
    return res.status;
  };

  const validateGeneral = () => {
    const name = $scope.organizationGeneral.name;
    const slug = $scope.organizationGeneral.slug;
    const timezone = $scope.organizationGeneral.timezone;
    const language = $scope.organizationGeneral.language;
    const website = $scope.organizationGeneral.website;
    const phoneNumber = validPhone($scope.organizationGeneral.phoneNumber);

    if (!name) {
      NotificationService.Warning($translate.instant('mandatory_name'));
      return false;
    }

    if (
      name &&
      !/^[a-zA-Zàáâäãåąč&ćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽð:/ ,.'-+\d.*-]+$/u.test(
        name,
      )
    ) {
      NotificationService.Warning($translate.instant('invalid_organization_name'));
      return false;
    }

    if (!slug) {
      NotificationService.Warning($translate.instant('mandatory_alias'));
      return false;
    }

    if (!language) {
      NotificationService.Warning($translate.instant('mandatory_language'));
      return false;
    }

    if (!timezone) {
      NotificationService.Warning($translate.instant('mandatory_timezone_place'));
      return false;
    }

    if (!$scope.data.selectedCategory || !$scope.data.selectedCategory.length > 0) {
      NotificationService.Warning($translate.instant('mandatory_category'));
      return false;
    }

    if (
      website &&
      !/(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9]\.[^\s]{2,})/.test(
        website.toLowerCase(),
      )
    ) {
      NotificationService.Warning($translate.instant('url regex'));
      return false;
    }
    if (phoneNumber && phoneNumber.length !== 10) {
      NotificationService.Warning($translate.instant('invalid_tel'));
      return false;
    }

    return true;
  };

  $scope.saveGeneral = () => {
    if (validateGeneral()) {
      $scope.organizationGeneral.categories = $scope.data.selectedCategory.map(
        (category) => category.key,
      );
      OrganizationService.UpdateGeneral($scope.organizationGeneral, $scope.organization._id)
        .then(() => {
          NotificationService.Success($translate.instant('organization_update_succ'));
          if ($scope.file.hasOwnProperty('logo') ||
            $scope.file.hasOwnProperty('agenda.logo') ||
            $scope.file.hasOwnProperty('agenda.background')) {
            saveImages($scope.organization._id, $scope.file);
          }
        })
        .catch(ErrorService.handler);
    }
  };

  const validateOneLogin = () => {
    if (!$scope.hack.organizationOneLoginEnabled) {
      return true;
    }

    const oneLogin = $scope.organizationOneLogin;
    const passportConfig = $scope.organizationOneLogin.passportConfig;

    if (!oneLogin.tenantId) {
      NotificationService.Warning($translate.instant('organization_onelogin_slug_required'));
      return false;
    }

    if (!passportConfig.clientID) {
      NotificationService.Warning($translate.instant('organization_onelogin_clientId_required'));
      return false;
    }

    if (!passportConfig.issuer) {
      NotificationService.Warning($translate.instant('organization_onelogin_issuer_required'));
      return false;
    }

    if (!passportConfig.tokenURL) {
      NotificationService.Warning($translate.instant('organization_onelogin_tokenurl_required'));
      return false;
    }

    if (!passportConfig.userInfoURL) {
      NotificationService.Warning($translate.instant('organization_onelogin_userinfourl_required'));
      return false;
    }

    if (!passportConfig.clientSecret) {
      NotificationService.Warning(
        $translate.instant('organization_onelogin_clientSecret_required'),
      );
      return false;
    }

    if (!passportConfig.authorizationURL) {
      NotificationService.Warning(
        $translate.instant('organization_onelogin_authorizationurl_required'),
      );
      return false;
    }

    if (!passportConfig.callbackURL) {
      NotificationService.Warning($translate.instant('organization_onelogin_callbackurl_required'));
      return false;
    }

    return true;
  };

  const validateConfigurations = () => {
    const checkInTolerance = $scope.organization.configuration.queuer.checkInTolerance;
    const defaultScenario = $scope.organization.defaultScenario;
    const checkIn = $scope.organization.configuration.checkIn;
    const showNextAvailableSlot = get($scope.organization.configuration, 'agenda.showNextAvailableSlot.enabled', false);
    const showNextSlotInLessThan = get($scope.organization.configuration, 'agenda.showNextAvailableSlot.showNextSlotInLessThan', 0);
    const noAppointmentsAvailableMessage = $scope.organization.configuration.noAppointmentsAvailableMessage;
    const extraAppointmentQuantity = get($scope.organization, 'configuration.extraAppointment.quantity', 0);
    const productDeliveryProcessedPlacesLimit = get($scope.organizationConfiguration, 'productDelivery.processedPlacesLimit', 0);
    const productDeliveryNextDaysLimit = get($scope.organizationConfiguration, 'productDelivery.nextDaysLimit', 0);

    if ($scope.scenarioList.length > 1 && !defaultScenario) {
      NotificationService.Warning($translate.instant('mandatory_defaultScenario'));
      return false;
    }

    if (!$scope.organization.configuration.queuer.qr) {
      $scope.organizationConfiguration.queuer.qr = `${Slug.slugify(
        $scope.organization.name,
      )}_check_in`;
    }

    if (
      checkInTolerance && (
        (checkInTolerance > 100 || checkInTolerance < 2) || checkInTolerance.toString().indexOf('.') === 1)
    ) {
      NotificationService.Warning($translate.instant('organization_checkin_tolerance_range'));
      return false;
    }

    if (!checkIn || !checkIn.max || checkIn.max < 5 || checkIn.max > 1000) {
      NotificationService.Warning($translate.instant('error_pre_check_in_invalid_range'));
      return false;
    }

    if (!checkIn || !checkIn.min || checkIn.min < 5 || checkIn.min > 1000) {
      NotificationService.Warning($translate.instant('error_pre_check_in_invalid_range'));
      return false;
    }

    if (showNextAvailableSlot && (showNextSlotInLessThan < 1 || showNextSlotInLessThan > 480)) {
      NotificationService.Warning($translate.instant('agenda_show_next_available_slot_range'));
      return false;
    }

    if (!validateOneLogin()) {
      return false;
    }

    if (noAppointmentsAvailableMessage.length > 150) {
      NotificationService.Warning($translate.instant('noAppointments_message_too_long'));
      return false;
    }

    if (!isValidLastDigit()) {
      return false;
    }

    if (!isValidLastDigitShowCommercialOffer()) {
      return false;
    }

    if (!isNumber(extraAppointmentQuantity) || extraAppointmentQuantity > 15 || extraAppointmentQuantity < 1) {
      NotificationService.Warning($translate.instant('extra_appointment_max_min'));
      return false;
    }

    if (!isNumber(productDeliveryProcessedPlacesLimit) || productDeliveryProcessedPlacesLimit > 10 || productDeliveryProcessedPlacesLimit < 1) {
      NotificationService.Warning($translate.instant('productDelivery_nextDaysLimit_max_min'));
      return false;
    }

    if (!isNumber(productDeliveryNextDaysLimit) || productDeliveryNextDaysLimit > 90 || productDeliveryNextDaysLimit < 1) {
      NotificationService.Warning($translate.instant('productDelivery_processedPlacesLimit_max_min'));
      return false;
    }

    return true;
  };

  const validateMessages = () => {
    const organizationMessages = $scope.organizationMessages;
    const messagesCondition = organizationMessages.find((organizationMessage) =>
      organizationMessage.messages.find((message) => !message),
    );
    if (messagesCondition) {
      NotificationService.Warning($translate.instant('messages_required'));
      return false;
    } else {
      return true;
    }
  };

  const removeEmptyReasons = () => {
    $scope.organizationConfiguration.reasons = removeEmptyItems($scope.organizationConfiguration.reasons);
    $scope.organizationConfiguration.pausedReasons = removeEmptyItems($scope.organizationConfiguration.pausedReasons);
  };

  $scope.saveConfigurations = () => {
    if (validateConfigurations()) {
      const oneLogin = $scope.hack.organizationOneLoginEnabled ? $scope.organizationOneLogin : null;

      const { defaultLineFlowTypeOrganization } = $scope.organization;

      const { defaultScenario } = $scope.organization;

      const noAppointmentsAvailableApplyIn =
        $scope.noAppointmentsAvailableMessageApplyIn.selectedOption;
      $scope.organizationConfiguration['noAppointmentsAvailableApplyIn'] =
        noAppointmentsAvailableApplyIn;

      const applyThisVersionOfTotemToAllPlaces = $scope.selectDataForTotem.selectedOption;
      const applyExtraAppointmentToAllPlaces = $scope.selectDataForExtraAppointment.selectedOption;
      const applyAgingSLAToAllPlaces = $scope.editSlaScope.selectedOption;
      removeEmptyReasons();

      OrganizationService.UpdateConfiguration(
        {
          configuration: $scope.organizationConfiguration,
          enabledForMobileApp: $scope.organization.enabledForMobileApp,
          hiddenInMobileApp: $scope.organization.hiddenInMobileApp,
          defaultLineFlowTypeOrganization,
          lineFlowTypeApplyIn: $scope.editCallLogicsScope.selectedOption,
          defaultScenario,
          oneLogin,
          applyThisVersionOfTotemToAllPlaces,
          applyExtraAppointmentToAllPlaces,
          applyAgingSLAToAllPlaces,
        },
        $scope.organization._id,
      )
        .then(() => {
          if ($scope.originalSlaEnabled !== $scope.organizationConfiguration.agingSLA.enabled) {
            if ($scope.organizationConfiguration.agingSLA.enabled) {
              NotificationService.Warning($translate.instant('organization_sla_enable_all_place'));
            } else {
              NotificationService.Warning($translate.instant('organization_sla_disable_all_place'));
            }

            $scope.originalSlaEnabled = $scope.organizationConfiguration.agingSLA.enabled;
          }
          NotificationService.Success($translate.instant('organization_update_succ'));
          $rootScope.$broadcast('org-updated', $scope.organization);
          if ($state.params.placeId) {
            PlaceService.GetOneAsPromiseFromServer($state.params.placeId)
              .then((place) => {
                $timeout(() => {
                  $scope.place = place;
                  GlobalsService.SetCurrentPlace(place);
                });
              })
              .catch(ErrorService.handler);
          } else {
            $rootScope.$broadcast('update-all-places-in-place-list');
          }

          if (!$scope.organizationConfiguration.agingSLA.enabled) {
            if ($state.current.name === 'app.organization-sla') {
              $state.go(SAFE_STATES.placesList);
            } else if ($state.current.name === 'app.place-sla') {
              $state.go(SAFE_STATES.nowServing);
            }
          }
        })
        .catch(() => NotificationService.Error($translate.instant('err_operation')));
    }
  };

  $scope.saveMessages = () => {
    if (validateMessages()) {
      const forAllPlaces = $scope.editMessagesScope.selectedOption === 'all';

      OrganizationMessagesService.UpdateAllMessages(
        $scope.organizationMessages,
        $scope.organization._id,
        forAllPlaces,
      )
        .then(() => NotificationService.Success($translate.instant('organization_update_succ')))
        .catch(() => NotificationService.Error($translate.instant('err_operation')));
    }
  };

  $scope.addReason = () => {
    const reasons = get($scope.organization, 'configuration.reasons', []);
    if (containsEmptyElements(reasons)) {
      NotificationService.Information($translate.instant('reason_empty'));
      return false;
    }
    $scope.organization.configuration.reasons.unshift('');
  };

  $scope.addPausedReason = () => {
    if ($scope.organization.configuration.pausedReasons) {
      const reasons = get($scope.organization, 'configuration.pausedReasons', []);
      if (containsEmptyElements(reasons)) {
        NotificationService.Information($translate.instant('reason_empty'));
        return false;
      }
      $scope.organization.configuration.pausedReasons.unshift('');
    } else {
      $scope.organization.configuration.pausedReasons = [];
      $scope.organization.configuration.pausedReasons.unshift('');
    }
  };

  $scope.deleteReason = (reason) => {
    dialog
      .confirm($translate.instant('reason_remove_sure'))
      .then(() => {
        pull($scope.organization.configuration.reasons, reason);
        NotificationService.Information($translate.instant('reason_remove_succ'));
      })
      .catch(ErrorService.handler);
  };

  $scope.deletePausedReason = (reason) => {
    dialog
      .confirm($translate.instant('reason_remove_sure'))
      .then(() => {
        pull($scope.organization.configuration.pausedReasons, reason);
        NotificationService.Information($translate.instant('reason_remove_succ'));
      })
      .catch(ErrorService.handler);
  };

  $scope.requestReasonAndMotiveChange = (value) => {
    $scope.organization.configuration.reasons = [];
    if (!value) {
      $scope.organization.configuration.reasonRequired = false;
    }
  };

  $scope.userBoxChange = (value) => {
    if (value) {
      $scope.organization.configuration.queuer.boxLabelRequired = false;
    }
  };

  $scope.adminBoxChange = (value) => {
    if (value) {
      $scope.organization.configuration.user.useBoxLabelByPace.enabled = false;
      $scope.organization.configuration.user.useBoxLabelByPace.required = false;
    }
  };

  $scope.defaultAppointmentConfirmation = () => {
    if (
      !$scope.organizationConfiguration.queuer.canGiveAppointments ||
      !$scope.organizationConfiguration.queuer.canConfirmAppointments
    ) {
      $scope.organizationConfiguration.queuer.requireAppointmentConfirmation = false;
    }
    if (!$scope.organizationConfiguration.queuer.canGiveAppointments) {
      $scope.organization.configuration.queuer.showWorkingDay = false;
    }
    if (!$scope.organization.configuration.queuer.canGiveAppointments) {
      $scope.organization.configuration.queuer.canProcessAppointment = false;
    }
    if ($scope.organizationConfiguration.queuer.canGiveAppointments) {
      $scope.organizationConfiguration.queuer.canConfirmAppointments = true;
    }
  };

  $scope.checkAliasType = () => {
    const aliasType = get($scope, 'organization.configuration.queuer.aliasType');
    const requiredId = get($scope, 'organization.configuration.requirements.id');

    if (!requiredId && aliasType === lastIdAlias) {
      $scope.organization.configuration.queuer.aliasType = 'fullNameAlias';
      NotificationService.Information($translate.instant('alias_has_been_changed'));
    }
  };

  $scope.isDynamicAlias = () => {
    const aliasType = get($scope, 'organization.configuration.queuer.aliasType');
    const aliasGetter = get($scope, 'organization.configuration.queuer.aliasGetter');
    const isDinamycAlias = aliasType === 'dynamicAlias';

    if (isDinamycAlias && !aliasGetter) {
      const fun = `
/* context = {_, subscription} 
  * _ = lodash
  * virtualine subscription 
  */
 (function() { return _.get(subscription, '_id', 'default-value')}());
      `;
      set($scope, 'organization.configuration.queuer.aliasGetter', fun);
    }

    return isDinamycAlias;
  };

  $scope.uploadFile = (files, type) => {
    if (files.length > 0) {
      var ext = files[0].name.match(/\.(.+)$/)[1];
      $timeout(() => {
        $scope.file[type] = files[0];
      })
      if (!angular.lowercase(ext) === 'jpg' || !angular.lowercase(ext) === 'jpeg' || !angular.lowercase(ext) === 'png') {
        NotificationService.Warning($translate.instant('invalid_file_format'));
      }
    }
  }

  $scope.onFileChange = (event) => {
    $scope.nameImg[event.target.dataset.type] = event.target.files[0].name;
    $scope.uploadFile(event.target.files, event.target.dataset.type);
  }

  function saveImages(id, files) {
    NotificationService.Information($translate.instant('uploading_images'));
    return OrganizationService.SaveImages(id, files)
      .then(() =>
        NotificationService.Information($translate.instant('updated_images')),
      )
      .catch(() =>
        NotificationService.Error($translate.instant('err_update_image')),
      );
  }

  $scope.deleteImage = (type) => {
    const defaultImage = 'img/common/placeholder-place.png';
    $timeout(() => {
      $scope.file[type] = null;
      $scope.nameImg[type] = '';
      switch (type) {
        case 'logo':
          $scope.logoSrc = defaultImage;
          break;
        case 'agenda.logo':
          $scope.agendaLogoSrc = defaultImage;
          break;
        case 'agenda.background':
          $scope.agendaBackgroundSrc = defaultImage;
          break;
      }
    })
  }

  $scope.checkDependentServices = () => {
    if (!$scope.organizationConfiguration.lastDigitsToCallServiceClient.enabled) {
      $scope.organization.configuration.showCommercialOffer.enabledService = $scope.organizationConfiguration.lastDigitsToCallServiceClient.enabled;
    }
  }

  const init = () => {
    let enqueueBlock = blockUI.instances.get('organization-modal');
    enqueueBlock.start();

    const categoriesPromises = CategoryService.GetAllAsPromise();
    const aliasTypesPromises = OrganizationService.GetAliasTypes();

    const organizationMessagesPromise = organizationId
      ? OrganizationMessagesService.GetAllAsPromise(organizationId)
      : [];

    const organizationPromise = organizationId
      ? OrganizationService.GetOneAsPromiseFromServer(organizationId)
      : null;

    const lftoPromise = organizationId
      ? LineFlowTypeOrganizationService.GetAllEnabledByOrganization(organizationId, false)
      : [];

    const slaPromise = organizationId ? OrganizationSlaService.GetAllEnabled(organizationId) : [];

    const scenarioPromise = organizationId
      ? OrganizationScenarioService.GetAll(organizationId)
      : [];

    const plansPromise = $scope.superAdmin ? PlanService.GetAllActive() : [];

    const promises = [
      categoriesPromises,
      aliasTypesPromises,
      organizationMessagesPromise,
      organizationPromise,
      lftoPromise,
      slaPromise,
      scenarioPromise,
      plansPromise,
    ];

    return Promise.all(promises)
      .then(
        ([
          categories,
          aliasTypes,
          messages,
          organization,
          lftoList,
          slaList,
          scenarioList,
          plans,
        ]) => {
          $scope.data = {
            aliasTypes,
            categories,
            selectedCategory: [],
          };

          $scope.plans = plans;

          if (organizationId) {
            $timeout(() => {
              $scope.lineFlowTypeOrganizationList = lftoList;
              $scope.slaOrganizationList = slaList;

              $scope.lineFlowTypeOrganizationSelected =
                find(lftoList, ['_id', organization.defaultLineFlowTypeOrganization]) ||
                lineFlowTypeOrganizationList[0];

              $scope.slaOrganizationSelected =
                find(slaList, { _id: organization.configuration.agingSLA?._id }) ||
                $scope.slaOrganizationList[0];

              $scope.organizationMessages = messages;
              $scope.organization = OrganizationService.Copy(organization);
              $scope.organizationGeneral = $scope.organization.getGeneralPartial();
              $scope.organizationConfiguration = $scope.organization.getConfigurationPartial();
              const organizationOneLogin = $scope.organization.getOneLoginConfigurationPartial();
              if ($scope.organizationConfiguration.currentTotemVersion) {
                $scope.totemVersionSelected = optionsTotemVersion.filter(
                  (ver) => ver.version === $scope.organizationConfiguration.currentTotemVersion,
                )[0];
              } else {
                $scope.totemVersionSelected = optionsTotemVersion[0];
                $scope.organizationConfiguration.currentTotemVersion =
                  optionsTotemVersion[0].version;
              }
              $scope.organizationOneLogin = organizationOneLogin;
              $scope.hack.organizationOneLoginEnabled = organizationOneLogin.enabled;

              $scope.organization.categories.forEach((category) => {
                const c = find($scope.data.categories, ['key', category]);
                if (c) {
                  $scope.data.selectedCategory.push(c);
                }
              });

              $scope.scenarioList = scenarioList;
              $scope.scenarioList.unshift({
                name: '',
                value: '',
              });

              $scope.scenarioSelected =
                find(scenarioList, ['_id', organization.defaultScenario]) || scenarioList[0];
              $scope.logoSrc =
                organization.images.logo ||
                organization.images.thumbnail ||
                'img/common/placeholder-place.png';
              $scope.agendaLogoSrc = organization.images.agenda.logo
                ? organization.images.agenda.logo
                : 'img/common/placeholder-place.png';
              $scope.agendaBackgroundSrc = organization.images.agenda.background
                ? organization.images.agenda.background
                : 'img/common/placeholder-place.png';
              $scope.organizationConfiguration.productDelivery.processedPlacesLimit = get(
                $scope.organizationConfiguration,
                'productDelivery.processedPlacesLimit',
                1,
              );
              $scope.organizationConfiguration.productDelivery.nextDaysLimit = get(
                $scope.organizationConfiguration,
                'productDelivery.nextDaysLimit',
                7,
              );
              $scope.organizationConfiguration.agingSLA._id =
                organization.configuration.agingSLA?._id !== ''
                  ? organization.configuration.agingSLA?._id
                  : $scope.slaOrganizationSelected._id;

              $scope.originalSlaEnabled = $scope.organizationConfiguration.agingSLA.enabled;
            });
          }

          enqueueBlock.stop();
        },
      )
      .catch(() => $scope.cancel());
  };

  init();
};

module.exports = module.controller('OrganizationModalController', OrganizationModalController);
